<template>
    <v-app class="contentAll">
        <v-layout row wrap>
            <v-flex d-flex>
                <v-layout justify-space-between>
                    <v-flex xs12>
                        <v-layout justify-start>
                            <img class="logoDiba" :src="logoDiba" alt="">
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-end column>
                            <v-flex xs12>
                                <v-layout justify-end>
                                    <v-btn type="button" round color="#FF7BA3" class="whiteText" v-on:click="toHome">
                                        <v-icon>exit_to_app</v-icon>
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout justify-end>
                                    <exPanel></exPanel>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout justify-center align-center fill-height class="testLayout">
            <v-flex md1 xs1 lg1>

                <div v-show="this.$store.state.showFinishTimeImg">
                    <h1 class="finishTimeText animated flash">{{$t('finishTimeText')}}</h1>
                </div>
                <v-layout justify-center align-center>
                    <v-flex class="containerWinCategoryClass" v-show="$store.state.showMessageWinCategory">
                        <div class="messageWinCategory animated zoomInRight" :style="{'background': $store.state.colorQuiz}">
                            <b>{{this.$store.state.messageWinCategory}}</b>
                            <br>
                            <i class="infoProbabilitat">{{$t('info')}}</i>
                        </div>
                    </v-flex>
                </v-layout>
                <div class="wrapper animated bounceInDown">
                    <div class="circle-container swing">
                        <div class="circle" v-for="i in 120"
                             :key="i"
                             v-on:click="move(i)"
                        >
                            <div v-for="option in options">
                                <div v-if="i === option">
                                    <div v-if="i === 1" class="hoverMovementCircle"></div>
                                    <div v-if="i !== 1" class="hoverMovement"></div>
                                </div>
                            </div>
                            <div v-if="i === 1 && answerCorrectPadronetx === false">
                                <img v-show="!iconFailedBoolean" class="padronet animated" :src="padronetxNeutreGeneral"
                                     alt="">
                            </div>
                            <div v-if="i === 1 && answerCorrectPadronetx === true">
                                <img class="padronetAlegre animated" :src="padronetxAlegreGeneral" alt="">
                            </div>
                            <div v-if="i === 1 && answerCorrectPadronetx !== true">
                                <img v-show="iconFailedBoolean" class="iconFailed" :src="padronetxTristGeneral" alt="">
                            </div>
                            <div v-if="i === 100"><img class="logoEstrangeria" :src="logoEstrangeria" alt=""></div>
                            <div v-if="i === 120"><img class="logoCX" :src="logoCX" alt=""></div>
                            <div v-if="i === 115"><img class="logoDocuments" :src="logoDocuments" alt=""></div>
                            <div v-if="i === 95"><img class="logoEmpadronament" :src="logoEmpadronament" alt="">
                            </div>
                            <div v-if="i === 105"><img class="logoCensElectoral" :src="logoCensElectoral" alt="">
                            </div>
                            <div v-if="i === 110"><img class="logoTerritori" :src="logoTerritori" alt=""></div>
                            <div v-if="i === 98"><img class="logos" :src="logoTornaTirar" alt=""></div>
                            <div v-if="i === 103"><img class="logos" :src="logoTornaTirar" alt=""></div>
                            <div v-if="i === 108"><img class="logos" :src="logoTornaTirar" alt=""></div>
                            <div v-if="i === 113"><img class="logos" :src="logoTornaTirar" alt=""></div>
                            <div v-if="i === 118"><img class="logos" :src="logoTornaTirar" alt=""></div>
                            <div v-if="i === 93"><img class="logos" :src="logoTornaTirar" alt=""></div>

                            <div v-if="i === token" v-model="changeOptions">
                                <div class="tokenStyle animated flash"></div>
                            </div>

                            <div v-show="confettiON" class="confetti">
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex d-flex>
                <v-layout justify-space-between>
                    <v-flex xs12>
                        <v-layout justify-start>
                            <Quesito
                                    :category-number="categoryNumber"
                                    :sum-category="sendCategory"
                            ></Quesito>
                            <v-layout></v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 class="pointsClass">
                        <v-layout justify-center align-start fill-height>
                            <PointsMenu class="layoutPoints"></PointsMenu>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-center align-start>
                            <div class="containerDice animated" v-on:click="animateDice">
                                <div :class="{dice1: dauShow1}" v-on:click="moveDice()">
                                    <div class="dot"></div>
                                </div>
                                <div :class="{dice2: dauShow2}" v-on:click="moveDice()">
                                    <div class="dot" v-for="i in 2" :key="i"></div>
                                </div>
                                <div :class="{dice3: dauShow3}" v-on:click="moveDice()">
                                    <div class="dot" v-for="i in 3" :key="i"></div>
                                </div>
                                <div :class="{dice4: dauShow4}" v-on:click="moveDice()">
                                    <div class="dot" v-for="i in 4" :key="i"></div>
                                </div>
                                <div :class="{dice5: dauShow5}" v-on:click="moveDice()">
                                    <div class="dot" v-for="i in 5" :key="i"></div>
                                </div>
                                <div :class="{dice6: dauShow6}" class="initDice animated" v-on:click="moveDice()">
                                    <div class="dot" v-for="i in 6" :key="i"></div>
                                </div>
                            </div>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <Quiz
                :category-name="categoryQuestion"
                v-on:resultQuestionChild="resultQuestionParent"
        ></Quiz>
        <FinishGame></FinishGame>
    </v-app>
</template>
<script>
    import firebase from 'firebase'
    import Noty from 'noty';
    import {db} from '../firebaseConfig'

    let usersRef = db.ref('Users');

    import padronetNeutre from '../img/Logo_el_Padronet_normal.png';
    import padronetAlegre from '../img/padronet_celebracio_v2_groc_120_x_120_pixels_500_milisegons.gif';
    import padronetTrist from '../img/Logo_el_Padronet_errada.png'

    import padronetaNeutre from '../img/Logo_la_Padroneta_normal.png';
    import padronetaAlegre from '../img/la_padroneta_celebracio_v1_groc_120_x_120_pixels_500_milisegons.gif';
    import padronetaTrist from '../img/Logo_la_Padroneta_errada.png';


    import logoEstrangeria from '../img/Categoria_05_Estrangeria_60_x_60_pixels_v3.png'
    import logoCX from '../img/Categoria_06_Cues_i_xifres_60_x_60.png'
    import logoDocuments from '../img/Categoria_02_Documents_60_x_60.png'
    import logoEmpadronament from '../img/Categoria_01_Empadronament_60_x_60_pixels.png'
    import logoCensElectoral from '../img/Categoria_03_Cens_electoral_60_x_60.png'
    import logoTerritori from '../img/Categoria_04_Territori_60_x_60_pixels.png'
    import logoTornaTirar from '../img/Categoria_07_torna_a_tirar.png'
    import logoDiba from '../img/Marca DB DO negatiu quadrat.png'

    import Quesito from '../components/Quesito'
    import PointsMenu from "./PointsMenu";
    import Quiz from '../components/Quiz'
    import FinishGame from '../components/FinishGame'
    import exPanel from '../components/expansionPanel'

    import {Trans} from '../plugins/Translation'

    import apareixPreguntaSound from '../Sounds/apareix pregunta.mp3'
    import moureDauSound from '../Sounds/dau_2.mp3'
    import faltamoureDau from '../Sounds/faltaMoureDau.mp3'


    //NORMATIVA = CENS ELECTORAL

    export default {
        name: "Board",
        components: {
            Quiz,
            Quesito,
            PointsMenu,
            FinishGame,
            exPanel
        },
        data() {
            return {
                //mostrar confetti
                confettiON: false,
                token: 0,
                options: [],
                values: [
                    [1, 5],
                    [1, 10],
                    [1, 15],
                    [1, 20],
                    [1, 25],
                    [1, 30],
                    [5, 1],
                    [5, 35],
                    [10, 1],
                    [10, 40],
                    [15, 1],
                    [15, 45],
                    [20, 1],
                    [20, 50],
                    [25, 1],
                    [25, 55],
                    [30, 1],
                    [30, 60],
                    [35, 5],
                    [35, 65],
                    [40, 10],
                    [40, 70],
                    [45, 15,],
                    [45, 75],
                    [50, 20],
                    [50, 80],
                    [55, 25],
                    [55, 85],
                    [60, 30],
                    [60, 90],
                    [65, 35],
                    [65, 95],
                    [70, 40],
                    [70, 100],
                    [75, 45],
                    [75, 105],
                    [80, 50],
                    [80, 110],
                    [85, 55],
                    [85, 115],
                    [90, 60],
                    [90, 120],
                    [95, 94],
                    [95, 96],
                    [95, 65],
                    [96, 95],
                    [96, 97],
                    [97, 96],
                    [97, 98],
                    [98, 97],
                    [98, 99],
                    [99, 98],
                    [99, 100],
                    [100, 99],
                    [100, 101],
                    [100, 70],
                    [101, 100],
                    [101, 102],
                    [102, 101],
                    [102, 103],
                    [103, 102],
                    [103, 104],
                    [104, 103],
                    [104, 105],
                    [105, 104],
                    [105, 106],
                    [105, 75],
                    [106, 105],
                    [106, 107],
                    [107, 106],
                    [107, 108],
                    [108, 107],
                    [108, 109],
                    [109, 108],
                    [109, 110],
                    [110, 109],
                    [110, 111],
                    [110, 80],
                    [111, 110],
                    [111, 112],
                    [112, 111],
                    [112, 113],
                    [113, 112],
                    [113, 114],
                    [114, 113],
                    [114, 115],
                    [115, 114],
                    [115, 116],
                    [115, 85],
                    [116, 115],
                    [116, 117],
                    [117, 116],
                    [117, 118],
                    [118, 117],
                    [118, 119],
                    [119, 118],
                    [119, 120],
                    [120, 119],
                    [120, 91],
                    [120, 90],
                    [91, 120],
                    [91, 92],
                    [92, 91],
                    [92, 93],
                    [93, 92],
                    [93, 94],
                    [94, 93],
                    [94, 95],
                ],
                CuesXifres: [10, 35, 75, 104, 106, 112],
                Documents: [5, 60, 70, 99, 101, 107],
                Empadronament: [15, 40, 80, 109, 111, 117],
                Estrangeria: [20, 45, 85, 92, 114, 116],
                censElectoral: [25, 50, 90, 91, 97, 119],
                Territori: [30, 55, 65, 94, 96, 102],
                Empty: [93, 98, 103, 108, 113, 118],
                //sumar categoria
                categoryCheese: [120, 95, 100, 105, 110, 115],
                categoryQuestion: "",
                categoryNumber: 0,
                answerCorrect: false,
                sendCategory: false,

                answerCorrectPadronetx: false,

                padronetxNeutreGeneral: null,
                padronetxAlegreGeneral: null,
                padronetxTristGeneral: null,

                padronetxNeutre: null,
                padronetxAlegre: padronetAlegre,
                padronetxTrist: null,


                iconFailedBoolean: false,
                iconCorrectBoolean: false,
                logoEstrangeria: logoEstrangeria,
                logoCX: logoCX,
                logoDocuments: logoDocuments,
                logoEmpadronament: logoEmpadronament,
                logoCensElectoral: logoCensElectoral,
                logoTerritori: logoTerritori,
                logoTornaTirar: logoTornaTirar,
                logoDiba: logoDiba,
                //DAU
                dau: {
                    dau1: 1,
                    dau2: 2,
                    dau3: 3,
                    dau4: 4,
                    dau5: 5,
                    dau6: 6
                },
                dauShow1: false,
                dauShow2: false,
                dauShow3: false,
                dauShow4: false,
                dauShow5: false,
                dauShow6: true,
                valueDice: 1,
                showQuizParent: false

            }
        },
        created() {
            this.token = 1;
            this.$store.commit('changeCanMoveDiceTrue');
            this.$store.commit('finishGameFalse');
            this.$store.commit('changeSumCategoryFalse');
            this.$store.commit('changeShowRankingFalse');

            //sound
            let faltamoureDauSong = new Audio(faltamoureDau);
            setTimeout(() => {

                faltamoureDauSong.play();
            },2000);

            let this2 = this;

            //cambiar el padronetx
            firebase.auth().onAuthStateChanged(function (user) {
                usersRef.child(user.uid).child('padronetx')
                    .on('value', function (snap) {
                        if (snap.val() === "1") {
                            this2.padronetxNeutreGeneral = padronetaNeutre;

                            this2.padronetxNeutre = padronetaNeutre;
                            this2.padronetxAlegre = padronetaAlegre;
                            this2.padronetxTrist = padronetaTrist;

                        } else if (snap.val() === "2") {
                            this2.padronetxNeutreGeneral = padronetNeutre;

                            this2.padronetxNeutre = padronetNeutre;
                            this2.padronetxAlegre = padronetAlegre;
                            this2.padronetxTrist = padronetTrist;
                        }
                    });
            });
            // control idioma al recarregar
            let lang;
            let path = window.location.pathname;

            if (path === '/jocPadro/cat/board') {
                lang = 'cat';

            } else if (path === '/jocPadro/es/board') {
                lang = 'es';
            }
            const to = this.$router.resolve({params: {lang}});
            return Trans.changeLanguage(lang).then(() => {
                this.$router.push(to.location);
            });
        },
        methods: {
            //Rep la informacio de Quiz, si ha encertat o fallat la pregunta
            resultQuestionParent(number) {
                if (number.correct === true) {

                    //que la imatge central es canvii per el padronetalegre
                    this.answerCorrectPadronetx = true;

                    this.padronetxAlegreGeneral = this.padronetxAlegre;

                    //treue el component Quiz
                    this.sendCategory = true;
                    //icone a false
                    this.iconFailedBoolean = false;

                    //confetti/celebracio temps
                    let this2 = this;
                    this2.secondsCrono = 2;
                    this.confettiON = true;

                    let inter = setInterval(function () {
                        this2.secondsCrono--;
                        if (this2.secondsCrono === 0) {
                            clearInterval(inter);
                            this2.confettiON = false;
                            this2.answerCorrectPadronetx = false;
                        }
                        if (this2.secondsCrono < 0) {
                            this2.secondsCrono = 0;
                            clearInterval(inter);
                        }
                    }, 1000);

                    //animar
                    setTimeout(() => {
                        let elem = document.querySelector('.padronetAlegre');
                        if (!elem.classList.contains('flip')) {
                            elem.classList.add('flip')
                        }
                        setTimeout(() => {
                            elem.classList.remove('flip');
                        }, 1000);
                    }, 100);


                    let this3 = this;
                    let crono = 3;

                    let inter2 = setInterval(function () {
                        crono--;
                        if (crono === 0) {
                            clearInterval(inter);
                            // this3.padronet = padronetNeutre;
                            this3.padronetxAlegreGeneral = this3.padronetxAlegre;
                        }
                        if (crono < 0) {
                            crono = 0;
                            // this3.padronet = padronetNeutre;
                            this3.padronetxAlegreGeneral = this3.padronetxAlegre;

                            clearInterval(inter2);
                        }
                    }, 1000);

                } else {
                    //mostrar el icon failed padronet
                    this.iconFailedBoolean = true;

                    this.padronetxTristGeneral = this.padronetxTrist;
                    // animar
                    let elem = document.querySelector('.iconFailed');
                    if (!elem.classList.contains('flash')) {
                        elem.classList.add('flash')
                    }

                }

            },
            move: function (i) {

                this.showQuizParent = false;
                this.$store.commit('changeLastQuestionFalse');
                //nomes es pot moure la fitxa en les caselles possibles donades pel dau
                for (let j = 0; j < this.options.length; j++) {

                    if (this.options[j] === i) {
                        this.token = i;

                        //comença el cronometre de quiz
                        this.$store.commit('changeStartCronoQuizTrue');

                        this.categoryNumber = this.token;

                        for (let j = 0; j < this.CuesXifres.length; j++) {
                            if (this.token === this.CuesXifres[j]) {
                                this.categoryQuestion = "Cues i Xifres";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#B78DE4");
                            }
                        }
                        for (let j = 0; j < this.Documents.length; j++) {
                            if (this.token === this.Documents[j]) {
                                this.categoryQuestion = "Documents";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#FCE15C");
                            }
                        }
                        for (let j = 0; j < this.Empadronament.length; j++) {
                            if (this.token === this.Empadronament[j]) {
                                this.categoryQuestion = "Empadronament";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#FF7BA3");
                            }
                        }
                        for (let j = 0; j < this.Estrangeria.length; j++) {
                            if (this.token === this.Estrangeria[j]) {
                                this.categoryQuestion = "Estrangeria";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#2dde98");
                            }
                        }
                        for (let j = 0; j < this.censElectoral.length; j++) {
                            if (this.token === this.censElectoral[j]) {
                                this.categoryQuestion = "Cens electoral";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#F5DABD");
                            }
                        }
                        for (let j = 0; j < this.Territori.length; j++) {
                            if (this.token === this.Territori[j]) {
                                this.categoryQuestion = "Territori";
                                this.showQuizParent = true;
                                this.$store.commit('changeColorQuiz', "#ffc2e5");
                            }
                        }

                        let tornaATirar = false;
                        for (let j = 0; j < this.Empty.length; j++) {
                            if (this.token === this.Empty[j]) {
                                tornaATirar = true;
                                if (Trans.currentLanguage === 'cat') {
                                    this.categoryQuestion = "Torna a tirar";

                                } else if (Trans.currentLanguage === 'es') {
                                    this.categoryQuestion = "Vuelve a tirar";

                                }
                                this.$store.commit('changeCanMoveDiceTrue');
                            }
                        }

                        if (tornaATirar === true) {
                            new Noty({
                                layout: 'topCenter',
                                type: 'warning',
                                text: this.categoryQuestion,
                                timeout: 3000
                            }).show();
                        }


                        for (let j = 0; j < this.categoryCheese.length; j++) {
                            if (this.token === this.categoryCheese[j]) {
                                if (this.token === 120) {
                                    this.categoryQuestion = "Cues i Xifres";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#B78DE4");
                                }
                                if (this.token === 95) {
                                    this.categoryQuestion = "Empadronament";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#FF7BA3");
                                }
                                if (this.token === 100) {
                                    this.categoryQuestion = "Estrangeria";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#2dde98");

                                }
                                if (this.token === 105) {
                                    this.categoryQuestion = "Cens electoral";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#F5DABD");

                                }
                                if (this.token === 110) {
                                    this.categoryQuestion = "Territori";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#ffc2e5");

                                }
                                if (this.token === 115) {
                                    this.categoryQuestion = "Documents";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#FCE15C");

                                }
                            }
                        }

                        //Pregunta aleatoria

                        if (this.token === 1) {

                            let numberFix = 0;

                            for (let k = 0; k < 20; k++) {
                                let numberRandom = Math.floor(Math.random() * 120) + 1;
                                if ((numberRandom % 5) === 0) {
                                    numberFix = numberRandom;
                                }
                            }

                            for (let j = 0; j < this.CuesXifres.length; j++) {
                                if (numberFix === this.CuesXifres[j]) {
                                    this.categoryQuestion = "Cues i Xifres";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#B78DE4");

                                }
                            }
                            for (let j = 0; j < this.Documents.length; j++) {
                                if (numberFix === this.Documents[j]) {
                                    this.categoryQuestion = "Documents";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#FCE15C");


                                }
                            }
                            for (let j = 0; j < this.Empadronament.length; j++) {
                                if (numberFix === this.Empadronament[j]) {
                                    this.categoryQuestion = "Empadronament";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#FF7BA3");

                                }
                            }
                            for (let j = 0; j < this.Estrangeria.length; j++) {
                                if (numberFix === this.Estrangeria[j]) {
                                    this.categoryQuestion = "Estrangeria";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#2dde98");


                                }
                            }
                            for (let j = 0; j < this.censElectoral.length; j++) {
                                if (numberFix === this.censElectoral[j]) {
                                    this.categoryQuestion = "Cens electoral";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#F5DABD");


                                }
                            }
                            for (let j = 0; j < this.Territori.length; j++) {
                                if (numberFix === this.Territori[j]) {
                                    this.categoryQuestion = "Territori";
                                    this.showQuizParent = true;
                                    this.$store.commit('changeColorQuiz', "#ffc2e5");

                                }
                            }
                        }

                        //reset options
                        this.options = [];
                    }
                }
                if (this.showQuizParent === true) {
                    let apareixPreguntaSong = new Audio(apareixPreguntaSound);

                    apareixPreguntaSong.play();

                    this.$store.commit('showQuizTrue');
                    this.$store.commit('showQuizTrue2');
                } else {
                    this.$store.commit('showQuizFalse');
                    this.$store.commit('showQuizFalse2');
                }
            },
            possibleMovements(id, diceValue, previous) {
                let newArray = [];
                if (diceValue > 0) {
                    for (let i = 0; i < this.values.length; i++) {
                        //guardo els valors en una nova array
                        newArray[i] = this.values[i];
                    }
                    for (let x = 0; x < newArray.length; x++) {
                        //els valors han de ser iguals a la posició del dau
                        if (newArray[x][0] === id) {
                            if (newArray[x][1] !== previous) {
                                this.possibleMovements(newArray[x][1], diceValue - 1, newArray[x][0])
                            }
                        }
                    }
                } else if (id !== previous) {
                    this.options.push(id)
                }
            },
            moveDice() {

                //sound
                let moureDauSong = new Audio(moureDauSound);

                moureDauSong.play();

                this.sendCategory = false;
                if (this.$store.state.canMoveDice === true) {
                    this.showQuizParent = false;

                    this.valueDice = Math.floor(Math.random() * 6) + 1;

                    // console.log("dice: " + this.numberDice);

                    if (this.valueDice === this.dau.dau1) {
                        this.dauShow1 = true;
                        this.dauShow2 = false;
                        this.dauShow3 = false;
                        this.dauShow4 = false;
                        this.dauShow5 = false;
                        this.dauShow6 = false;
                    }
                    if (this.valueDice === this.dau.dau2) {
                        this.dauShow1 = false;
                        this.dauShow2 = true;
                        this.dauShow3 = false;
                        this.dauShow4 = false;
                        this.dauShow5 = false;
                        this.dauShow6 = false;
                    }
                    if (this.valueDice === this.dau.dau3) {
                        this.dauShow1 = false;
                        this.dauShow2 = false;
                        this.dauShow3 = true;
                        this.dauShow4 = false;
                        this.dauShow5 = false;
                        this.dauShow6 = false;
                    }
                    if (this.valueDice === this.dau.dau4) {
                        this.dauShow1 = false;
                        this.dauShow2 = false;
                        this.dauShow3 = false;
                        this.dauShow4 = true;
                        this.dauShow5 = false;
                        this.dauShow6 = false;
                    }
                    if (this.valueDice === this.dau.dau5) {
                        this.dauShow1 = false;
                        this.dauShow2 = false;
                        this.dauShow3 = false;
                        this.dauShow4 = false;
                        this.dauShow5 = true;
                        this.dauShow6 = false;
                    }
                    if (this.valueDice === this.dau.dau6) {
                        this.dauShow1 = false;
                        this.dauShow2 = false;
                        this.dauShow3 = false;
                        this.dauShow4 = false;
                        this.dauShow5 = false;
                        this.dauShow6 = true;
                    }
                    this.changeOptions();

                }
                //moure mes d'un cop
                this.$store.commit('changeCanMoveDiceFalse');
            }
            ,
            changeOptions() {
                this.options = [];
                this.possibleMovements(this.token, this.valueDice, null)
            },
            animateDice() {
                let elem = document.querySelector('.containerDice');
                if (!elem.classList.contains('flip')) {
                    elem.classList.add('flip')
                }
                setTimeout(() => {
                    elem.classList.remove('flip')
                }, 300);
            },
            toHome() {
                this.$router.replace('home');

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');


    $yellow: #B78DE4;
    $blue: #FCE15C;
    $pink: #FF7BA3;

    $duration: 1000;

    @function randomNum($min, $max) {
        $rand: random();
        $randomNum: $min + floor($rand * (($max - $min) + 1));

        @return $randomNum;
    }

    .infoProbabilitat{
        font-size: 10px;
    }

    .whiteText {
        color: white;
    }

    .logoDiba {
        position: absolute;
        padding: 10px;
        width: 150px;
    }

    //ICONS

    .containerWinCategoryClass {
        position: absolute;
        top: 25%;
        z-index: 1;
        width: 90%;
        text-align: center;
        justify-content: center;
        border-radius: 20px;
        opacity: 0.5%;
        font-size: 20px;
    }

    .messageWinCategory {
        color: white;
        background: #FF7BA3;
        text-transform: uppercase;
        font-family: 'Josefin Sans', sans-serif;
        border-radius: 20px;
        padding: 5%;
        /*box-shadow: 0px 0px 10px white;*/
    }

    .iconFinishTime {
        position: absolute;
        left: 23%;
        z-index: 1;
    }

    .finishTimeText {
        position: absolute;
        top: 20%;
        font-size: 200px;
        left: 25%;
        z-index: 2;
        color: white;
        text-shadow: 10px 10px 20px #666;
    }

    .iconFailed {
        z-index: 1;
        position: absolute;
        margin-top: 6%;
        width: 120px;
        height: 120px;
        left: 8%;
        animation: failedAnimation 3s;

    }

    @keyframes failedAnimation {
        0% {
            transform: scale(10);
        }
        50% {
            transform: scale(5);
        }
        100% {
            transform: scale(1);
        }
    }

    .icon {
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 32px;
        position: relative;
    }

    .confetti {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
        height: 200px;
        overflow: hidden;
    }

    .confetti-piece {
        position: absolute;
        width: 8px;
        height: 16px;
        background: $yellow;
        top: 0;
        opacity: 0;

        @for $i from 1 through 13 {
            &:nth-child(#{$i}) {
                left: $i * 7%;
                transform: rotate(#{randomNum(-80, 80)}deg);
                animation: makeItRain $duration * 1ms infinite ease-out;
                animation-delay: #{randomNum(0, $duration * .6)}ms;
                animation-duration: #{randomNum($duration * .6, $duration * 1.0)}ms
            }
        }

        &:nth-child(odd) {
            background: $blue;
        }

        &:nth-child(even) {
            z-index: 1;
        }

        &:nth-child(4n) {
            width: 5px;
            height: 12px;
            animation-duration: $duration * 2ms;
        }

        &:nth-child(3n) {
            width: 3px;
            height: 10px;
            animation-duration: $duration * 2.5ms;
            animation-delay: $duration * 1ms;
        }

        &:nth-child(4n-7) {
            background: $pink;
        }
    }

    @keyframes makeItRain {
        from {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        to {
            transform: translateY(200px);
        }
    }


    //

    * {
        margin-top: 0;
        padding: 0;
        border-top: 0;
    }

    //LOGOS

    .logos {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
    }

    .logoEstrangeria {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(90deg);
    }

    .logoCX {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(0deg);
    }

    .logoDocuments {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(90deg);
    }

    .logoEmpadronament {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(-60deg);
    }

    .logoCensElectoral {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(-180deg);
    }

    .logoTerritori {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
        width: 50px;
        height: 50px;
        z-index: -1;
        transform: rotate(90deg);
    }

    .contentAll {
        background-image: linear-gradient(to right top, #2f89fc, #00a0ff, #00b4fd, #00c5f1, #00d3e4, #29d9df, #43dfd9, #5ae5d2, #71e6d8, #86e7dc, #98e8e1, #aae9e4);
    }


    //il·lumina els possibles moviments del token
    .hoverMovement {
        position: absolute;
        width: 60px;
        height: 60px;
        border-radius: 30%;
        opacity: 0.9;
        border: white 7px solid;

        &:hover {
            opacity: 0.5;
        }
    }

    .hoverMovementCircle {
        position: absolute;
        border-radius: 50%;
        top: 10%;
        left: 30%;
        margin-top: 20%;
        border: white 7px solid;
        width: 150px;
        height: 150px;
        transform: translateY(-30%) translateX(-30%);
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);

        &:hover {
            opacity: 0.5;
        }
    }

    //TOKEN
    .tokenStyle {
        z-index: 2;
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        left: 12%;
        margin-top: 13%;
        background: rgba(255, 255, 255, 0.7);
        box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.6);
        opacity: 0.2;
    }

    .padronet {
        position: absolute;
        width: 120px;
        height: 120px;
        left: 9%;
        margin-top: 6%;
        z-index: 1;

        @keyframes pound {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(8.1);
            }

        }
    }

    .padronetAlegre {
        position: absolute;
        width: 120px;
        height: 120px;
        left: 9%;
        margin-top: 6%;
        z-index: 1;

        @keyframes pound {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(8.1);
            }

        }
    }

    //TAULER


    .layoutPoints {
        margin-top: 20%;
    }

    .wrapper {
        width: 100%;
        height: 90%;
        z-index: 0;
    }

    .circle-container {
        position: relative;
        width: 100%;
        height: 80%;
        z-index: 0;
    }

    .circle {
        z-index: 1;
        position: absolute;
        width: 60px;
        height: 60px;
        border-radius: 30%;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

        &:nth-child(1) {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            transform: translateY(-30%) translateX(-30%);
            box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
        }

        &:nth-child(5n+0):hover {
            background-color: gray;
        }
    }

    .circle:hover {
        background-color: gray;
    }

    @for $i from 1 through 121 {

        .circle:nth-child(#{$i}) {


            @if $i>90 {
                transform: rotate($i*12deg) translateX(480%);
            } @else if $i>60 {
                transform: rotate($i*12deg) translateX(380%);
                width: 0;
                height: 0;
                @if ($i % 5) == 0 {
                    width: 60px;
                    height: 60px;
                }

            } @else if $i>30 {
                transform: rotate($i*12deg) translateX(280%);
                width: 0;
                height: 0;
                @if ($i % 5) == 0 {
                    width: 60px;
                    height: 60px;
                }
            } @else if $i > 1 {
                transform: rotate($i*12deg) translateX(180%);
                width: 0;
                height: 0;
                @if ($i % 5) == 0 {
                    width: 60px;
                    height: 60px;
                }
            } @else if $i > 1 {
                transform: translateX(235%) translateY(-30%);
            }


            //COLORS


            //Cues i xifres
            @if $i == 10 or $i == 35 or $i == 75 or $i == 120 or $i == 104 or $i == 106 or $i == 112 {
                background-color: #B78DE4;
                &:hover {
                    background-color: gray;
                }
            }

            //Documents
            @if $i == 5 or $i == 60 or $i == 70 or $i == 99 or $i == 101 or $i == 107 or $i == 115 {
                background-color: #FCE15C;
                &:hover {
                    background-color: gray;
                }
            }

            //Empadronament
            @if $i == 15 or $i == 40 or $i == 80 or $i == 109 or $i == 111 or $i == 117 or $i == 95 {
                background-color: #FF7BA3;
                &:hover {
                    background-color: gray;
                }
            }

            //Estrangeria
            @if $i == 20 or $i == 45 or $i == 85 or $i == 92 or $i == 114 or $i == 116 or $i == 100 {
                background-color: #2dde98;
                &:hover {
                    background-color: gray;
                }
            }

            //Cens electoral
            @if $i == 25 or $i == 50 or $i == 90 or $i == 91 or $i == 97 or $i == 119 or $i == 105 {
                background-color: #F5DABD;
                &:hover {
                    background-color: gray;
                }
            }

            //Territori
            @if $i == 30 or $i == 55 or $i == 65 or $i == 94 or $i == 96 or $i == 102 or $i == 110 {
                background-color: #ffc2e5;
                &:hover {
                    background-color: gray;
                }


            }
            @if $i == 93 or $i == 98 or $i == 103 or $i == 108 or $i == 113 or $i == 118 {
                background-color: #e7e7e7;
                &:hover {
                    background-color: gray;
                }
            }

            @if $i == 120 or $i == 95 or $i == 100 or $i == 105 or $i == 110 or $i == 115 {

                //a sobre de les altres caselles

            }

        }
    }


    //DAU


    .initDice {
        animation: animatedDiceInit 4s;
        animation-delay: 2s;
    }

    @keyframes animatedDiceInit {
        0% {
             transform: scale(1);
         }
        10% {
            transform: scale(2);
        }
        20% {
            transform: scale(1);
        }
        30% {
            transform: scale(2);
        }
        40% {
            transform: scale(1);
        }
        50% {
            transform: scale(2);
        }
        60% {
            transform: scale(1);
        }
        70% {
            transform: scale(2);
        }
        80% {
            transform: scale(1);
        }
        90% {
            transform: scale(2);
        }
        100% {
            transform: scale(1);
        }

    }

    .containerDice {
        margin-top: 10%;
    }

    .dice1 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            margin: auto;
        }

        &:hover {
            background: darkgray;

        }
    }

    .dice2 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;

            &:first-child {
                top: 20px;
                left: 20px;
            }

            &:last-child {
                bottom: 20px;
                right: 20px;
            }
        }

        &:hover {
            background: darkgray;
        }

    }

    .dice3 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;

            &:first-child {
                top: 15px;
                left: 15px;
            }

            &:nth-child(2) {
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                margin: auto;
            }

            &:last-child {
                bottom: 15px;
                right: 15px;
            }
        }

        &:hover {
            background: darkgray;
        }
    }

    .dice4 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;

            &:first-child {
                top: 15px;
                left: 15px;
            }

            &:nth-child(2) {
                top: 15px;
                right: 15px;
            }

            &:nth-child(3) {
                bottom: 15px;
                left: 15px;
            }

            &:last-child {
                bottom: 15px;
                right: 15px;
            }
        }

        &:hover {
            background: darkgray;
        }
    }

    .dice5 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;

            &:first-child {
                top: 15px;
                left: 15px;
            }

            &:nth-child(2) {
                top: 15px;
                right: 15px;
            }

            &:nth-child(3) {
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                margin: auto;
            }

            &:nth-child(4) {
                bottom: 15px;
                left: 15px;
            }

            &:last-child {
                bottom: 15px;
                right: 15px;
            }
        }

        &:hover {
            background: darkgray;
        }
    }

    .dice6 {
        border-radius: 20px;
        display: block;
        width: 100px;
        height: 100px;
        margin: 7px auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        background: lightgray;

        .dot {
            border-radius: 50%;
            position: absolute;
            width: 15px;
            height: 15px;
            background: #000;

            &:first-child {
                top: 15px;
                left: 15px;
            }

            &:nth-child(2) {
                top: 15px;
                right: 15px;
            }

            &:nth-child(3) {
                top: 0;
                bottom: 0;
                left: 15px;
                margin: auto;
            }

            &:nth-child(4) {
                top: 0;
                right: 15px;
                bottom: 0;
                margin: auto;
            }

            &:nth-child(5) {
                bottom: 15px;
                left: 15px;
            }

            &:last-child {
                bottom: 15px;
                right: 15px;
            }
        }

        &:hover {
            background: darkgray;
        }

    }


    //Adaptar tauler a movil
    @media only screen and (max-width: 720px) {


        .finishTimeText {
            position: absolute;
            top: 20%;
            font-size: 100px;
            left: 7%;
            z-index: 2;
            color: white;
            text-shadow: 10px 10px 20px #666;
        }

        .componentsBottom {
            display: flex;
            justify-content: space-between;
            margin-bottom: 50%;
        }


        //HOVER
        .hoverMovement {
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 30%;
            opacity: 0.9;
            border: white 5px solid;

            &:hover {
                background: white;
            }
        }

        .hoverMovementCircle {
            width: 75px;
            height: 75px;
        }

        //TOKEN

        .tokenStyle {
            width: 23px;
            height: 23px;
        }

        //BOARD

        .layoutPoints {
            margin-top: 0%;
        }

        .testLayout {
            height: 20%;
        }

        .circle {
            top: 40%;
        }

        .circle-container {
            margin: 0;
        }

        .circle {
            width: 30px;
            height: 30px;


            &:nth-child(1) {
                /*background: gold;*/
                width: 75px;
                height: 75px;
                border-radius: 50%;
                transform: translateY(-30%) translateX(-30%);
            }

        }


        @for $i from 1 through 121 {

            .circle:nth-child(#{$i}) {
                @if $i>90 {
                    transform: rotate($i*12deg) translateX(480%);
                } @else if $i>60 {
                    transform: rotate($i*12deg) translateX(380%);
                    width: 0;
                    height: 0;
                    @if ($i % 5) == 0 {

                        width: 30px;
                        height: 30px;
                    }

                } @else if $i>30 {
                    transform: rotate($i*12deg) translateX(280%);
                    width: 0;
                    height: 0;
                    @if ($i % 5) == 0 {

                        width: 30px;
                        height: 30px;
                    }
                } @else if $i > 1 {
                    transform: rotate($i*12deg) translateX(180%);
                    width: 0;
                    height: 0;
                    @if ($i % 5) == 0 {
                        width: 30px;
                        height: 30px;
                    }
                } @else if $i > 1 {
                    transform: translateX(235%) translateY(-30%);
                }

            }
        }

        //PADRONET

        .padronet {

            width: 60px;
            height: 60px;
            left: 9%;
            margin-top: 6%;

        }

        .padronetAlegre {
            width: 60px;
            height: 60px;
            left: 9%;
            margin-top: 6%;

        }

        //DAU
        .dice1 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;
            }
        }


        .dice2 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;

                &:first-child {
                    top: 10px;
                    left: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }
            }
        }

        .dice3 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;

                &:first-child {
                    top: 10px;
                    left: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }
            }

        }

        .dice4 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;

                &:first-child {
                    top: 10px;
                    left: 10px;
                }

                &:nth-child(2) {
                    top: 10px;
                    right: 10px;
                }

                &:nth-child(3) {
                    bottom: 10px;
                    left: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }
            }

        }

        .dice5 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;

                &:first-child {
                    top: 10px;
                    left: 10px;
                }

                &:nth-child(2) {
                    top: 10px;
                    right: 10px;
                }


                &:nth-child(4) {
                    bottom: 10px;
                    left: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }
            }

        }

        .dice6 {
            width: 60px;
            height: 60px;

            .dot {
                width: 11px;
                height: 11px;

                &:first-child {
                    top: 10px;
                    left: 10px;
                }

                &:nth-child(2) {
                    top: 10px;
                    right: 10px;
                }

                &:nth-child(3) {
                    top: 0;
                    bottom: 0;
                    left: 10px;
                    margin: auto;
                }

                &:nth-child(4) {
                    top: 0;
                    right: 10px;
                    bottom: 0;
                    margin: auto;
                }

                &:nth-child(5) {
                    bottom: 10px;
                    left: 10px;
                }

                &:last-child {
                    bottom: 10px;
                    right: 10px;
                }
            }
        }


        //QUESITO


        .containerDice {
            right: 20%;
        }

        .logos {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoEstrangeria {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoCX {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoDocuments {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoEmpadronament {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoCensElectoral {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .logoTerritori {
            margin-top: 2px;
            margin-left: 3px;
            width: 25px;
            height: 25px;
        }

        .wrapper {
            height: 400px;
        }


        //ICOS

        .iconFailed {
            width: 60px;
            height: 60px;
            left: 7%;

        }

        .pointsClass {
            margin-bottom: 50%;
        }
    }


</style>
